import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import {
  SurveyQuestion,
  AdministrativeUnitSurveyMessage,
} from "src/app/shared/models/survey";

@Component({
    selector: "lea-messages",
    templateUrl: "./lea-messages.component.html",
    styleUrls: ["./lea-messages.component.scss"],
    standalone: false
})
export class LeaMessagesComponent implements OnInit {
  @Input() messages: AdministrativeUnitSurveyMessage[] = [];
  @Output() newMessage = new EventEmitter();

  form: UntypedFormGroup;
  submitDisabled: boolean = true;

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      message: ["", [Validators.required]],
    });
    this.form.valueChanges.subscribe((value) => {
      this.submitDisabled = !this.form.valid;
    });
  }

  onPostMessageClick() {
    if (this.form.valid) {
      this.newMessage.emit([this.form.get("message").value as string, false]);

      this.form.reset();
    }
  }
}
